import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section aria-labelledby="transformation-title" className="bg-cream px-5 py-20 md:py-28" data-id="element-221" data-mp="31xicmqebhih6">
      <Reveal className="mx-auto max-w-content" data-id="element-222" data-mp="2wvsyh1vssoov">
        <div className="mx-auto max-w-3xl text-center" data-id="element-223" data-mp="2rz2ieejztt3g">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-224" data-mp="2s0nazymqz1yo">
            THE LACROSSE READY 360 TRANSFORMATION
          </p>
          <h2 id="transformation-title" className="mt-4 text-3xl font-extrabold leading-[1.1] tracking-tight text-pine md:text-[2.6rem]" data-id="element-225" data-mp="2j5z5q8h69k9v">
            From Improvising on the Sideline to{' '}
            <span className="italic text-amber" data-id="element-226" data-mp="299mhhq4ebymi">Coaching with Total Confidence.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl leading-relaxed text-slate-body" data-id="element-227" data-mp="248gmtmr6e1ac">
            <strong className="font-semibold text-ink" data-id="element-228" data-mp="208fz1bi6sdqm">LACROSSE READY 360™</strong> gives you the whole pathway, not a
            pile of loose drills. Every block builds on the one before it, so your season has a direction and your
            players can feel it.
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-4xl divide-y divide-slate-line rounded-card bg-white p-8 shadow-card md:grid-cols-3 md:divide-x md:divide-y-0 md:p-10" data-id="element-229" data-mp="5dxv70v8pnu7">
          {transformationStats.map(({
          value,
          label
        }) => <div key={value} className="px-4 py-6 text-center md:py-0" data-id="element-230" data-mp="y2d6pdf5xo0s">
              <strong className="block font-display text-2xl font-extrabold leading-tight text-pine md:text-3xl" data-id="element-231" data-mp="12zlsdnzisa6s">
                {value}
              </strong>
              <span className="mt-2.5 block text-sm leading-snug text-slate-body" data-id="element-232" data-mp="t2h5tn1ricpg">{label}</span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}